<template>
	<section class="productsBlock">
		<loading></loading>
		<div class="container">
			<div id="product-category-block" class="d-flex col-12 col-md-10 mx-auto mb-3 mb-md-5 mt-md-5 justify-content-around">
				<div class="row col-12 px-0">
					<div class="col-6 col-md-4 px-2">
						<span>商品種別</span><br>
						<select class="form-control w-100" name="select1" @change="pagemove()" v-model="s_category">
							<option value="0" name="all">すべて</option>
							<option v-for="cat in catPrd" :key="cat.index" :value="cat.name" name="">{{cat.displayName}}</option>
						</select>
					</div>
					<div class="col-6 col-md-4 px-2">
						<span>在庫状況</span><br>
						<select class="form-control w-100" name="select2" @change="pagemove()" v-model="s_stock">
							<option value="0" name="all">すべて</option>
							<option value="exist" name="exist">在庫あり</option>
						</select>
					</div>
					<div class="col-12 col-md-4 px-2 mt-md-0 mt-2">
						<span>表示順</span><br>
						<select class="form-control w-100" name="select2" @change="pagemove()" v-model="s_sort">
							<option value="0" name="new">新着順</option>
							<option value="row" name="row">価格の安い順</option>
							<option value="high" name="high">価格の高い順</option>
						</select>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-10 mx-2 mb-3" v-if="key != null">
				<small>検索ワード：{{key}}</small>
			</div>
			<div class="col-12 mt-5" v-if="isNotfound">
				<p class="text-center">商品が見つかりませんでした</p>
			</div>
			<div class="row" :class="fadeapp ? 'appear':'vanish'">
				<div class="col-6 col-md-4" v-for="prd in disList.slice(minSlice,minSlice+perPage)" :key="prd.index">
					<div class="card mb-4 box-shadow canClick" @click="toDetail(prd)">
						<img class="card-img-top" :src="imageSet(prd.images)" data-holder-rendered="true">
						<div class="card-body">
							<p
								class="stock-status"
								:class="judgeStatus(prd.variations, prd.categories)"
							></p>
							<p class="card-title mb-0 main-point-color">{{prd.title}}</p>
							<p class="card-text d-block">
								{{setPrice(prd.variations)}}円
								<small class="text-nowrap">（税込）</small>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="paging-product" class="mt-5">
			<nav class="nav_pagination mx-auto mt-5" aria-label="ページネーション" :hidden="!isVisible">
				<ul class="pagination justify-content-center">
					<li class="page-item canClick mx-1" :class="isFirst ? 'none':''" @click="preClick()">
						<a class="page-link" aria-label="前へ">
							<span aria-hidden="true" class="pre">«</span>
						</a>
					</li>
					<li v-if="(lastPage>5)&&(curPage>4)" class="cantClick page-link page-dots sp-none"><a><span>…</span></a></li>
					<template v-for="page of lastPage">
						<li class="page-item canClick sp-none mx-1" :class="activeNum(page)" v-if="page>(Number(curPage)-4) && page<(Number(curPage)+4)" :key="page.index" @click="pageClick(page)">
							<a class="page-link"><span>{{page}}</span></a>
						</li>
					</template> 
					<li v-if="(lastPage>5)&&(curPage<(lastPage-3))" class="cantClick page-link page-dots sp-none"><a><span>…</span></a></li>
					<li class="page-item canClick mx-1" :class="isLast ? 'none':''" @click="nextClick()">
						<a class="page-link" aria-label="次へ">
							<span aria-hidden="true" class="next">»</span>
						</a>
					</li>
				</ul>
			</nav>
		</div>
	</section>
</template>

<script>
	import loading from './loading.vue'
	import { productListMixin } from '../mixins/productListMixin.js'
	export default{
		mixins: [productListMixin],
		components:{
			loading
		},
		data(){
			return{
				host:process.env.VUE_APP_IAM,
				key:this.$route.query['keywords'],
				query:this.$route.query,
				path:this.$route.path
			}
		},
		created(){
			this.$store.commit('DATA_LOAD', true)
			this.clearOgp()
			this.getCategory()
			this.getData()
		},
		mounted(){
			document.getElementById('scrollTarget').scrollIntoView(true)
			scrollTo(0,0)
		},
		methods:{
			// products.vue固有のメソッド
			clearOgp(){
				const ogTitle = document.querySelector('meta[property="og:title"]')
				const ogImage = document.querySelector('meta[property="og:image"]')

				if(ogTitle){
					ogTitle.remove()
				}

				if(ogImage){
					ogImage.remove()
				}
			},
			async getData(){
				try{
					const products = await this.$axios.get(this.$uri+'/product')
					const stocks = await this.$axios.get(this.$uri+'/productStock')
					const category = await this.$axios.get(this.$uri+'/category')
					this.catList = category.data.categoryGroups
					this.catPrd = this.catList.find((v)=> v.name == 'category').categories
					this.prdList = products.data.products
					this.stkList = stocks.data
					this.prdList.sort((a,b)=>{
						if(a.validAfter > b.validAfter) return -1
						return 0
					})
					this.sortList()
					this.endLoad()
				}catch(e){
					if(e.response){
						if(e.response.status == 503 && e.response.headers['modd-cms-sitemaintenance'] == 1){
							window.location.href = "/maintenance/maintenance.html"
						}
					}else{
						window.location.href="/error/error.html"
					}
				}
			},
			toDetail(item){
				let code = item.variations[0].productCode
				this.$store.commit('CHANGE_ROOT','product')
				this.tagMove({path:'/product/detail/'+code, params:{'hin':code}})
			},
			setPageTitle(){
				if(this.key != void 0){
					document.title = '検索結果：' + this.key + ' / ufotableWEBSHOP'
				}else if(this.$route.query.cat != void 0){
					if(this.$route.query.cat != 0) {
						let pageCategoryArr
						for(var i=0; i<this.catList.length; i++){
							if(this.catList[i].categories.find((v)=> v.name == this.$route.query.cat) != void 0){
								pageCategoryArr = this.catList[i].categories.find((v)=> v.name == this.$route.query.cat)
							}
						}
						if(pageCategoryArr != void 0){
							let pageCategory = pageCategoryArr.displayName
							document.title = pageCategory + ' / ufotableWEBSHOP'
						}else{
							document.title = 'ufotableWEBSHOP'
						}
					}else{
						document.title = 'ufotableWEBSHOP'
					}
				}else{
					document.title = 'ufotableWEBSHOP'
				}
				this.path = this.$route.path + window.location.search
				this.$gtag.query('config', 'UA-196118927-1', {'page_path': this.path, 'page_title': document.title})
				this.$gtag.query('config', 'G-S69VXZJE85', {'page_path': this.path, 'page_title': document.title})
			},
			// ミックスインのメソッドをオーバーライド
			getKeyword() {
				return this.key
			},
			
			
			getPagePath(page) {
				return `/products/${page}`
			},
			
			sendPageGA(page) {
				this.$gtag.query('config', 'UA-196118927-1', {'page_path': '/products/'+page, 'page_title': document.title})
				this.$gtag.query('config', 'G-S69VXZJE85', {'page_path': '/products/'+page, 'page_title': document.title})
			},
			
			sortList(){
				this.setPageTitle()
				// ミックスインのsortListを呼び出し
				this.$options.mixins[0].methods.sortList.call(this)
			},
			getPagemoveUrl() {
				return `/products/1?cat=${this.s_category}&opt=${this.s_sort}&stock=${this.s_stock}`
			},
		},
	}
</script>